import React from "react"
import { useLocation } from "react-router-dom"

//Referrals
import ParticipantReferralLayout from "./Components/ParticipantReferralLayout"
import ReferralsList from "./Components/List"
import ReferralsAdd from "./Components/Add"
import ReferralsEdit from "./Components/Form"


//ReferralEntities
import ReferralEntitiesList from "../Partner/Components/EntityProfile/ReferralEntitiesList"
import ReferralEntityForm from "../Partner/Components/EntityProfile/Form/ReferralEntityForm"

//Routes
import ROUTES from "../../components/Routes/routesContants"


export default function Referrals() {
   const location = useLocation();

  switch(location.pathname){
    case ROUTES.PARTICIPANT_REFERRALS: 
      return(<ParticipantReferralLayout><ReferralsList/></ParticipantReferralLayout>)
    case ROUTES.PARTICIPANT_REFERRAL_ENTITIES: 
      return(<ParticipantReferralLayout><ReferralEntitiesList/></ParticipantReferralLayout>)
    case ROUTES.PARTICIPANT_REFERRAL_ENTITIES_ADD: 
      return(<ParticipantReferralLayout><ReferralEntityForm/></ParticipantReferralLayout>)      
    case ROUTES.REFERRALS:
    case ROUTES.REFERRALS_LIST:
      return(<ReferralsList/>)
    case ROUTES.REFERRAL_ADD:
      return(<ReferralsAdd/>)   
    case ROUTES.REFERRAL_ENTITIES:
      return(<ReferralEntitiesList/>) 
    case ROUTES.REFERRAL_ENTITY_ADD:
      return(<ReferralEntityForm/>)           
    default: 
      if(location.pathname.startsWith(ROUTES.REFERRAL_ENTITY_EDIT.substring(0, ROUTES.REFERRAL_ENTITY_EDIT.lastIndexOf("/")))){
        return(<ReferralEntityForm/>) 
      }else if(location.pathname.startsWith(ROUTES.PARTICIPANT_REFERRAL_ENTITIES_EDIT.substring(0, ROUTES.PARTICIPANT_REFERRAL_ENTITIES_EDIT.lastIndexOf("/")))){
        return(<ParticipantReferralLayout><ReferralEntityForm/></ParticipantReferralLayout>)     
      }else if(location.pathname.startsWith(ROUTES.PARTICIPANT_REFERRAL_EDIT.substring(0, ROUTES.PARTICIPANT_REFERRAL_EDIT.lastIndexOf("/")))){       
        return(<ParticipantReferralLayout><ReferralsEdit/></ParticipantReferralLayout>)             
      }else if(location.pathname.startsWith(ROUTES.REFERRAL_EDIT.substring(0, ROUTES.REFERRAL_EDIT.lastIndexOf("/")))){
        return <ReferralsEdit/>
      }else{
        return(
          <h1>Unknown route: {location.pathname}</h1>
        )
      }
    
 
  } 



}
